import { configureStore } from "@reduxjs/toolkit";
import authReducer from "@features/auth/authSlice";
import { assetTypeReducer } from "@features/assetType/assetTypeSlice";
import { processRoleReducer } from "@features/processRole/processRoleSlice";
import phaseFormReducer from "@features/phaseForm/phaseFormSlice";
import { AffiliateReducer } from "@features/affiliate/AffiliateSlice";
import { filledFormReducer } from "@features/filledForm/filledFormSlice";
import { UserReducer } from "@features/user/UserSlice";
import { RoleReducer } from "@features/role/RoleSlice";

import productReducer from "@features/Element/productSlice";
import { processReducer } from "@features/process/processSlice";
import { scheduleReducer } from "@features/schedule/scheduleSlice";
import { appointmentReducer } from "@features/appointment/appointmentSlice";
import { SectorReducer } from "@/features/sector";
import { DocumentReducer } from "@/features/document/DocumentSlice";
import { CategoryDocumentReducer } from "@/features/categorydocument";
import { TemplateReducer } from "@/features/template";
import { AreaReducer } from "@/features/area";
import { TechinicalReducer } from "@/features/techinicaldocument";
import { clientReducer } from "@/features/Client";
import { salesReducer } from "@/features/sales/salesSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    assetType: assetTypeReducer,
    processRole: processRoleReducer,
    phaseForm: phaseFormReducer,
    affiliate: AffiliateReducer,
    filledForm: filledFormReducer,
    client: clientReducer,
    sales: salesReducer,

    user: UserReducer,
    role: RoleReducer,
    categorydocument: CategoryDocumentReducer,

    document: DocumentReducer,
    template: TemplateReducer,

    sector: SectorReducer,
    area: AreaReducer,
    techinical: TechinicalReducer,


    product: productReducer,
    process: processReducer,
    schedule: scheduleReducer,
    appointment: appointmentReducer,
  },
  devTools: import.meta.env.MODE !== "production",

});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
